import { useRef,useState, useEffect } from "react";
import {
  Box,
  Button,
  Card,
  Grid,
  Divider,
  CardContent,
  Typography,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Dialog,
  DialogTitle,
  DialogContent,
  Stack,
} from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import { useNavigate } from "react-router-dom";
import { GlobalStyles } from "@mui/system";
import { useAuth } from "../../../../AuthProvider";
import { useReactToPrint } from "react-to-print";
import './HallticketList.css'
import { useParams } from "react-router-dom";
import { IconButton } from "@mui/material";
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
 
const formatExamType = (type) => {
  if (!type) return "";

  const [prefix, number] = type.split("-");

  switch (prefix) {
    case "FA":
      return `Formative Assessment - ${number}`;
    case "SA":
      return `Summative Assessment - ${number}`;
    default:
      return type;
  }
};

const HallTicketCard = ({ student, organizationDetails, board, filteredExamData, Examtype }) => {
  // Group exam data by date
  const groupedData = filteredExamData.reduce((acc, curr) => {
    if (!acc[curr.examDate]) acc[curr.examDate] = [];
    acc[curr.examDate].push(curr);
    return acc;
  }, {});

  // Function to convert time to minutes for sorting
  const getTimeValue = (time) => {
    if (!time || typeof time !== "string") return Number.MAX_SAFE_INTEGER;
    let normalized = time.replace(".", ":").trim();
    if (/^\d+\s?(AM|PM)$/i.test(normalized)) {
      normalized = normalized.replace(/(\d+)\s?(AM|PM)/i, "$1:00 $2");
    }
    const match = normalized.match(/(\d+):(\d+)\s?(AM|PM)/i);
    if (!match) return Number.MAX_SAFE_INTEGER;

    let [hours, minutes, period] = match.slice(1);
    let h = parseInt(hours, 10);
    const m = parseInt(minutes, 10);

    if (period.toUpperCase() === "PM" && h !== 12) h += 12;
    if (period.toUpperCase() === "AM" && h === 12) h = 0;

    return h * 60 + m;
  };

  // Sort exams in each date
  Object.keys(groupedData).forEach((date) => {
    groupedData[date].sort(
      (a, b) => getTimeValue(a.examTime) - getTimeValue(b.examTime)
    );
  });

  return (
    <Box className="print-card">
      <Paper
        className="ticket-card"
        elevation={3}
        sx={{ p: 2, border: "2px solid black", height: "100%" }}
      >
        {/* --- header ------------------------------------------------ */}
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Box width="20%">
            <img
              src={`data:image/jpeg;base64,${organizationDetails.schoolLogo}`}
              alt="Logo"
              style={{
                width: "100px",
                height: "100px",
                borderRadius: "50%",
                objectFit: "cover",
              }}
            />
          </Box>

          <Box textAlign="center" flexGrow={1}>
            <Grid item xs={12} sm={8}>
              <Grid container direction="column" spacing={1}>
                <Grid item>
                  <Typography variant="h4" sx={{ fontWeight: "bold", color: "red" }}>
                    {organizationDetails.schoolName}
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography variant="h5" sx={{ fontWeight: "bold" }}>
                    {formatExamType(Examtype)}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Typography
              sx={{
                mt: 2,
                paddingBottom: "15px",
                fontWeight: "bold",
                fontFamily: "Arial, sans-serif",
                fontSize: "12px",
                color: "#333",
                textAlign: "center",
              }}
            >
              HALLTICKET
            </Typography>
          </Box>
          <Box width="20%" />
        </Box>

        {/* --- body (student details) -------------------------------- */}
        <Divider sx={{ my: 1 }} />
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Box display="flex" alignItems="center">
              <Box minWidth={180}>
                <Typography fontWeight="bold">Name of the Student</Typography>
              </Box>
              <Typography sx={{ mx: 1 }}>:</Typography>
              <Box borderBottom="1px solid black" width="100%" pb={0.5}>
                <Typography variant="body1">
                  {`${student?.surName || ""} ${student?.firstName || ""} ${student?.lastName || ""}`}
                </Typography>
              </Box>
            </Box>
          </Grid>

          <Grid item xs={12}>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Box display="flex" alignItems="center">
                  <Box minWidth={180}>
                    <Typography fontWeight="bold">Class</Typography>
                  </Box>
                  <Typography sx={{ mx: 1 }}>:</Typography>
                  <Box borderBottom="1px solid black" width="100%" pb={0.5}>
                    <Typography variant="body1">{student?.romanNumberClass || ""}</Typography>
                  </Box>
                </Box>
              </Grid>
              <Grid item xs={6}>
                <Box display="flex">
                  <Box minWidth={100}>
                    <Typography fontWeight="bold" sx={{ paddingRight: "10px" }}>Section</Typography>
                  </Box>
                  <Typography sx={{ paddingRight: "5px" }}>:</Typography>
                  <Box borderBottom="1px solid black" width="100%" pb={0.5}>
                    <Typography variant="body1">{student?.sections || ""}</Typography>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12}>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Box display="flex" alignItems="center">
                  <Box minWidth={180}>
                    <Typography fontWeight="bold">Roll Number</Typography>
                  </Box>
                  <Typography sx={{ mx: 1 }}>:</Typography>
                  <Box borderBottom="1px solid black" width="100%" pb={0.5}>
                    <Typography variant="body1">{student?.studentRollNumber || ""}</Typography>
                  </Box>
                </Box>
              </Grid>
              <Grid item xs={6}>
                <Box display="flex">
                  <Box minWidth={100}>
                    <Typography fontWeight="bold" sx={{ paddingRight: "10px" }}>HallTicket No</Typography>
                  </Box>
                  <Typography sx={{ paddingRight: "5px" }}>:</Typography>
                  <Box borderBottom="1px solid black" width="100%" pb={0.5}>
                    <Typography variant="body1">{student?.studentHallTicket || ""}</Typography>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12}>
            <Box display="flex" alignItems="center">
              <Box minWidth={180}>
                <Typography fontWeight="bold">Father Name</Typography>
              </Box>
              <Typography sx={{ mx: 1 }}>:</Typography>
              <Box borderBottom="1px solid black" width="100%" pb={0.5}>
                <Typography variant="body1">
                  {[student?.surName, student?.fathersFirstName, student?.fathersLastName].filter(Boolean).join(" ") || "N/A"}
                </Typography>
              </Box>
            </Box>
          </Grid>
        </Grid>

        <Divider sx={{ my: 1 }} />

        {/* --- EXAM TABLE ----------------------------------------- */}
        <Table sx={{ mt: 2, border: "1px solid #000", width: "100%" }} size="small">
          <TableHead>
            <TableRow>
              <TableCell align="center" colSpan={5} sx={{ fontWeight: "bold", fontSize: "16px", border: "1px solid #000", padding: "8px" }}>
                Time Table For : {Examtype || '--'}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell align="center" sx={{ fontWeight: "bold", border: "1px solid #000", padding: "4px", fontSize: "14px" }}>S.No</TableCell>
              <TableCell align="center" sx={{ fontWeight: "bold", border: "1px solid #000", padding: "4px", fontSize: "14px" }}>Subject</TableCell>
              <TableCell align="center" sx={{ fontWeight: "bold", border: "1px solid #000", padding: "4px", fontSize: "14px" }}>Date</TableCell>
              <TableCell align="center" sx={{ fontWeight: "bold", border: "1px solid #000", padding: "4px", fontSize: "14px" }}>Time</TableCell>
              <TableCell align="center" sx={{ fontWeight: "bold", border: "1px solid #000", padding: "4px", fontSize: "14px" }}>Invigilator Signature</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {filteredExamData.length === 0 ? (
              <TableRow>
                <TableCell colSpan={5} sx={{ textAlign: "center" }}>
                  No TimeTable Data Available
                </TableCell>
              </TableRow>
            ) : (
              filteredExamData.map((row, index) => (
                <TableRow key={index} hover sx={{ backgroundColor: "white", "&:hover": { backgroundColor: "#f5f5f5" } }}>
                  <TableCell align="center" sx={{ border: "1px solid #000", padding: "4px" }}>{index + 1}</TableCell>
                  <TableCell align="center" sx={{ border: "1px solid #000", padding: "4px" }}>{row.subject}</TableCell>
                  <TableCell align="center" sx={{ border: "1px solid #000", padding: "4px" }}>{new Date(row.examDate).toLocaleDateString("en-GB")}</TableCell>
                  <TableCell align="center" sx={{ border: "1px solid #000", padding: "4px" }}>
                    {row.examTime && row.examTimeEnd ? `${row.examTime} - ${row.examTimeEnd}` : ""}
                  </TableCell>
                  <TableCell align="center" sx={{ border: "1px solid #000", padding: "4px" }}>{row.invigilatorSignature}</TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>

        {/* --- TIMINGS ------------------------------------------ */}
        <Typography sx={{ fontSize: "12px", fontWeight: "bold", mt: 1 }}>
          Timings: {[...new Set(filteredExamData.map(i => `${i.examTime} to ${i.examTimeEnd}`))].join(" / ")}
        </Typography>

        {/* --- FOOTER (Signatures) ------------------------------ */}
        <Box mt={4} display="flex" justifyContent="space-between">
          <Typography sx={{ fontSize: "12px", fontWeight: "bold" }}>Student Signature</Typography>
          <Box textAlign="center" sx={{ fontSize: "13px" }}>
            <Typography sx={{ mb: 1 }}>_________________</Typography>
            <Typography fontWeight="bold">Principal Signature</Typography>
          </Box>
        </Box>
      </Paper>
    </Box>
  );
};


const HallTicketCard2 = ({ student, organizationDetails, board, filteredExamData, Examtype }) => {
  // Group exam data by date
  const groupedData = filteredExamData.reduce((acc, curr) => {
    if (!acc[curr.examDate]) acc[curr.examDate] = [];
    acc[curr.examDate].push(curr);
    return acc;
  }, {});

  // Convert time to minutes for sorting
  const getTimeValue = (time) => {
    if (!time || typeof time !== "string") return Number.MAX_SAFE_INTEGER;
    let normalized = time.replace(".", ":").trim();
    if (/^\d+\s?(AM|PM)$/i.test(normalized)) {
      normalized = normalized.replace(/(\d+)\s?(AM|PM)/i, "$1:00 $2");
    }
    const match = normalized.match(/(\d+):(\d+)\s?(AM|PM)/i);
    if (!match) return Number.MAX_SAFE_INTEGER;

    let [hours, minutes, period] = match.slice(1);
    let h = parseInt(hours, 10);
    const m = parseInt(minutes, 10);

    if (period.toUpperCase() === "PM" && h !== 12) h += 12;
    if (period.toUpperCase() === "AM" && h === 12) h = 0;

    return h * 60 + m;
  };

  // Sort each group by time
  Object.keys(groupedData).forEach((date) => {
    groupedData[date].sort(
      (a, b) => getTimeValue(a.examTime) - getTimeValue(b.examTime)
    );
  });

  return (
    <Box className="print-card">
      <Paper
        className="ticket-card"
        elevation={3}
        sx={{ p: 2, border: "2px solid black", height: "100%" }}
      >
        {/* HEADER */}
        <Box display="flex" alignItems="center">
          <Box width="18%" display="flex" justifyContent="center">
            <img
              src={`data:image/jpeg;base64,${organizationDetails.schoolLogo}`}
              alt="Logo"
              style={{
                width: "68px",
                height: "68px",
                borderRadius: "50%",
                objectFit: "cover",
              }}
            />
          </Box>

          <Box flexGrow={1} textAlign="center">
            <Typography sx={{ fontSize: "15px", fontWeight: "bold", color: "red" }}>
              {organizationDetails.schoolName}
            </Typography>
            <Typography sx={{ fontSize: "13px", fontWeight: "bold" }}>
              {formatExamType(Examtype)}
            </Typography>
            <Typography sx={{ fontSize: "12px", fontWeight: "bold", mt: 0.5 }}>
              HALLTICKET
            </Typography>
          </Box>

          <Box width="18%" />
        </Box>

        <Divider sx={{ my: 1 }} />

        {/* STUDENT INFO */}
        <Grid container spacing={1}>
          <Grid item xs={4}>
            <Box display="flex" fontSize="12px">
              <Typography fontWeight="bold" sx={{ minWidth: 100 }}>Class</Typography>
              <Typography sx={{ mx: 0.5 }}>:</Typography>
              <Typography>{student?.romanNumberClass || "N/A"}</Typography>
            </Box>
          </Grid>

          <Grid item xs={4}>
            <Box display="flex" fontSize="12px">
              <Typography fontWeight="bold" sx={{ minWidth: 100 }}>Section</Typography>
              <Typography sx={{ mx: 0.5 }}>:</Typography>
              <Typography>{student?.sections || "N/A"}</Typography>
            </Box>
          </Grid>

          <Grid item xs={4}>
            <Box display="flex" fontSize="12px">
              <Typography fontWeight="bold" sx={{ minWidth: 100 }}>Roll No</Typography>
              <Typography sx={{ mx: 0.5 }}>:</Typography>
              <Typography>{student?.studentRollNumber || "N/A"}</Typography>
            </Box>
          </Grid>

          <Grid item xs={4}>
            <Box display="flex" fontSize="12px">
              <Typography fontWeight="bold" sx={{ minWidth: 100 }}>Name</Typography>
              <Typography sx={{ mx: 0.5 }}>:</Typography>
              <Typography noWrap>{`${student?.surName || ""} ${student?.firstName || ""} ${student?.lastName || ""}`}</Typography>
            </Box>
          </Grid>

          <Grid item xs={4}>
            <Box display="flex" fontSize="12px">
              <Typography fontWeight="bold" sx={{ minWidth: 100 }}>Father Name</Typography>
              <Typography sx={{ mx: 0.5 }}>:</Typography>
              <Typography noWrap>
                {[student?.surName, student?.fathersFirstName, student?.fathersLastName].filter(Boolean).join(" ") || "N/A"}
              </Typography>
            </Box>
          </Grid>

          <Grid item xs={4}>
            <Box display="flex" fontSize="12px">
              <Typography fontWeight="bold" sx={{ minWidth: 100 }}>HallTicket No</Typography>
              <Typography sx={{ mx: 0.5 }}>:</Typography>
              <Typography>{student?.studentHallTicket || "N/A"}</Typography>
            </Box>
          </Grid>
        </Grid>

        <Divider sx={{ my: 1 }} />

        {/* EXAM TABLE */}
       <Table size="small" sx={{ border: "1px solid black", mt: 0.8, width: "100%" }}>
  <TableHead>
    {/* Exam Date Row */}
    <TableRow>
      <TableCell
        align="center"
        sx={{
          fontWeight: "bold",
          border: "1px solid black",
          padding: "6px",
        }}
      >
        Exam Date
      </TableCell>

      {filteredExamData.map((row, index) => (
        <TableCell
          key={index}
          align="center"
          sx={{
            border: "1px solid black",
            padding: "6px",
          }}
        >
          {new Date(row.examDate).toLocaleDateString("en-GB")}
        </TableCell>
      ))}
    </TableRow>

    {/* Subject Row */}
    <TableRow>
      <TableCell
        align="center"
        sx={{
          fontWeight: "bold",
          border: "1px solid black",
          padding: "6px",
        }}
      >
        Subject
      </TableCell>

      {filteredExamData.map((row, index) => (
        <TableCell
          key={index}
          align="center"
          sx={{
            border: "1px solid black",
            padding: "6px",
            fontSize: "12px",
          }}
        >
          {row.subject}
        </TableCell>
      ))}
    </TableRow>

    {/* Invigilator Signature Row */}
    <TableRow>
      <TableCell
        align="center"
        sx={{
          fontWeight: "bold",
          border: "1px solid black",
          padding: "6px",
        }}
      >
        Invigilator Signature
      </TableCell>

      {filteredExamData.map((row, index) => (
        <TableCell
          key={index}
          align="center"
          sx={{
            border: "1px solid black",
            padding: "6px",
          }}
        >
          {/* Empty cell for signature */}
        </TableCell>
      ))}
    </TableRow>
  </TableHead>
</Table>


        {/* TIMINGS */}
        <Typography sx={{ fontSize: "12px", fontWeight: "bold", mt: 1 }}>
          Timings: {[...new Set(filteredExamData.map(i => `${i.examTime} to ${i.examTimeEnd}`))].join(" / ")}
        </Typography>

        {/* SIGNATURES */}
        <Box sx={{ mt: "4mm", display: "flex", justifyContent: "space-between" }}>
          <Typography sx={{ fontSize: "12px", fontWeight: "bold" }}>Incharge Signature</Typography>
          <Typography sx={{ fontSize: "12px", fontWeight: "bold" }}>Principal Signature</Typography>
        </Box>
      </Paper>
    </Box>
  );
};



const HallTicketCard3 = ({
  student,
  organizationDetails,
  board,
  filteredExamData,
  Examtype,
}) => {
  // Group exams by date
  const groupedData = filteredExamData.reduce((acc, curr) => {
    if (!acc[curr.examDate]) acc[curr.examDate] = [];
    acc[curr.examDate].push(curr);
    return acc;
  }, {});

  // Convert time string to minutes for sorting
  const getTimeValue = (time) => {
    if (!time || typeof time !== "string") return Number.MAX_SAFE_INTEGER;
    let normalized = time.replace(".", ":").trim();
    if (/^\d+\s?(AM|PM)$/i.test(normalized)) {
      normalized = normalized.replace(/(\d+)\s?(AM|PM)/i, "$1:00 $2");
    }
    const match = normalized.match(/(\d+):(\d+)\s?(AM|PM)/i);
    if (!match) return Number.MAX_SAFE_INTEGER;

    let [hours, minutes, period] = match.slice(1);
    let h = parseInt(hours, 10);
    const m = parseInt(minutes, 10);

    if (period.toUpperCase() === "PM" && h !== 12) h += 12;
    if (period.toUpperCase() === "AM" && h === 12) h = 0;

    return h * 60 + m;
  };

  // Sort exams by time for each date
  Object.keys(groupedData).forEach((date) => {
    groupedData[date].sort(
      (a, b) => getTimeValue(a.examTime) - getTimeValue(b.examTime)
    );
  });

  // Function to format exam type
  const formatExamType = (type) => type || "Exam";

  return (
    <Box className="print-card">
      <Paper
        className="print-inner"
        elevation={0}
        sx={{ height: "100%", padding: "6px" }}
      >
        {/* HEADER */}
        <Box display="flex" alignItems="center">
          {/* LEFT LOGO */}
          <Box width="18%" display="flex" justifyContent="center">
            <img
              src={`data:image/jpeg;base64,${organizationDetails.schoolLogo}`}
              alt="Logo"
              style={{
                width: "68px",
                height: "68px",
                borderRadius: "50%",
                objectFit: "cover",
              }}
            />
          </Box>

          {/* CENTER TEXT */}
          <Box flexGrow={1} textAlign="center">
            <Typography sx={{ fontSize: "15px", fontWeight: "bold", color: "red" }}>
              {organizationDetails.schoolName}
            </Typography>
            <Typography sx={{ fontSize: "13px", fontWeight: "bold" }}>
              {formatExamType(Examtype)}
            </Typography>
            <Typography sx={{ fontSize: "12px", fontWeight: "bold", mt: 0.5 }}>
              HALLTICKET
            </Typography>
          </Box>

          {/* RIGHT EMPTY SPACE */}
          <Box width="18%" />
        </Box>

        <Divider sx={{ my: 0.7 }} />

        {/* STUDENT INFO */}
        <Grid container spacing={0.8}>
          {/* ROW 1 */}
          <Grid item xs={4}>
            <Box display="flex" fontSize="12px">
              <Typography fontWeight="bold" sx={{ minWidth: 100 }}>Class</Typography>
              <Typography sx={{ mx: 0.5 }}>:</Typography>
              <Typography>{student?.romanNumberClass || "N/A"}</Typography>
            </Box>
          </Grid>

          <Grid item xs={4}>
            <Box display="flex" fontSize="12px">
              <Typography fontWeight="bold" sx={{ minWidth: 100 }}>Section</Typography>
              <Typography sx={{ mx: 0.5 }}>:</Typography>
              <Typography>{student?.sections || "N/A"}</Typography>
            </Box>
          </Grid>

          <Grid item xs={4}>
            <Box display="flex" fontSize="12px">
              <Typography fontWeight="bold" sx={{ minWidth: 100 }}>Roll No</Typography>
              <Typography sx={{ mx: 0.5 }}>:</Typography>
              <Typography>{student?.studentRollNumber || "N/A"}</Typography>
            </Box>
          </Grid>

          {/* ROW 2 */}
          <Grid item xs={4}>
            <Box display="flex" fontSize="12px">
              <Typography fontWeight="bold" sx={{ minWidth: 100 }}>Name</Typography>
              <Typography sx={{ mx: 0.5 }}>:</Typography>
              <Typography noWrap>
                {`${student?.surName || ""} ${student?.firstName || ""} ${student?.lastName || ""}`}
              </Typography>
            </Box>
          </Grid>

          <Grid item xs={4}>
            <Box display="flex" fontSize="12px">
              <Typography fontWeight="bold" sx={{ minWidth: 100 }}>Father Name</Typography>
              <Typography sx={{ mx: 0.5 }}>:</Typography>
              <Typography noWrap>
                {[student?.surName, student?.fathersFirstName, student?.fathersLastName].filter(Boolean).join(" ") || "N/A"}
              </Typography>
            </Box>
          </Grid>

          <Grid item xs={4}>
            <Box display="flex" fontSize="12px">
              <Typography fontWeight="bold" sx={{ minWidth: 100 }}>HallTicket No</Typography>
              <Typography sx={{ mx: 0.5 }}>:</Typography>
              <Typography>{student?.studentHallTicket || "N/A"}</Typography>
            </Box>
          </Grid>
        </Grid>

        <Divider sx={{ my: 0.7 }} />

        {/* EXAM TABLE */}
        <Table size="medium" sx={{ border: "1px solid black", mt: 0.8 }}>
          <TableHead>
            {/* Exam Dates Row */}
            <TableRow>
              <TableCell
                sx={{ fontSize: "12px", fontWeight: "bold", border: "1px solid black", padding: "6px", textAlign: "center" }}
              >
                Exam Date
              </TableCell>

              {Object.keys(groupedData).map((date, i) => (
                <TableCell
                  key={i}
                  sx={{ fontSize: "13px", border: "1px solid black", padding: "6px", textAlign: "center" }}
                >
                  {new Date(date).toLocaleDateString("en-GB")}
                </TableCell>
              ))}
            </TableRow>

            {/* Subjects Row */}
            <TableRow>
              <TableCell
                sx={{ fontSize: "13px", fontWeight: "bold", border: "1px solid black", padding: "6px", textAlign: "center" }}
              >
                Subject
              </TableCell>

              {Object.keys(groupedData).map((date, i) => (
                <TableCell
                  key={i}
                  sx={{ border: "1px solid black", padding: "6px", textAlign: "center", fontSize: "12px" }}
                >
                  {groupedData[date].map(item => item.subject).join(" / ")}
                </TableCell>
              ))}
            </TableRow>

            {/* Invigilator Row */}
            <TableRow>
              <TableCell
                sx={{ fontSize: "13px", fontWeight: "bold", border: "1px solid black", padding: "10px", textAlign: "center" }}
              >
                Invigilator
              </TableCell>

              {Object.keys(groupedData).map((_, i) => (
                <TableCell key={i} sx={{ border: "1px solid black", padding: "10px" }} />
              ))}
            </TableRow>
          </TableHead>
        </Table>

        {/* TIMINGS */}
        <Typography sx={{ fontSize: "12px", fontWeight: "bold", mt: 0.6 }}>
          Timings:{" "}
          {[...new Set(filteredExamData.map(i => `${i.examTime} to ${i.examTimeEnd}`))].join(" / ")}
        </Typography>

        {/* SIGNATURES */}
        <Box sx={{ mt: "6mm", display: "flex", justifyContent: "space-between" }}>
          <Typography sx={{ fontSize: "12px", fontWeight: "bold" }}>Incharge Signature</Typography>
          <Typography sx={{ fontSize: "12px", fontWeight: "bold" }}>Principal Signature</Typography>
        </Box>
      </Paper>
    </Box>
  );
};



const Hallticketslist = () => {
  const navigate = useNavigate();
  const componentRef = useRef();
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(true);
  const { oId,board ,userId,role,pId,} = useAuth();
  const baseUrl = process.env.REACT_APP_API_BASE_URL;
  const { Examtype } = useParams();
  const [originalData, setOriginalData] = useState([]); // Original API data
const [sscClassOptions, setSscClassOptions] = useState([]);
const [sscSectionOptions, setSscSectionOptions] = useState([]);
const [sscSelectedClass, setSscSelectedClass] = useState("");
const [sscSelectedSection, setSscSelectedSection] = useState("");

// INTERMEDIATE states
const [interSectionOptions, setInterSectionOptions] = useState([]);
const [interSelectedClass, setInterSelectedClass] = useState("Inter-1st-Year");
const [interSelectedSection, setInterSelectedSection] = useState("");
const [courseOptions, setCourseOptions] = useState([]);
const [selectedCourseType, setSelectedCourseType] = useState("");
const [sscClassSectionMap, setSscClassSectionMap] = useState({});
const [course, setCourse] = useState([]);
 const [open, setOpen] = useState(false);
 const [prefix, setHallTicketPrefix] = useState("");
  const [hallticketprefixloading, sethallticketprefixLoading] = useState(false);
   const [generating, setGenerating] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [selectedHallTheme, setSelectedHallTheme] = useState("HallTicketTemplate");

useEffect(() => {
  const fetchSavedHallTheme = async () => {
    try {
      const res = await fetch(`${baseUrl}/api/principal/getTheme/${pId}`);
      const data = await res.json();

      if (data.hallTicketTheme) {
        setSelectedHallTheme(data.hallTicketTheme);
      }
     
    } catch (error) {
      console.error("Error fetching saved Hall Ticket theme:", error);
    }
  };

  fetchSavedHallTheme();
}, [pId, baseUrl]);
// ✅ Mapping themes to components
const themeComponents = {
  HallTicketTemplate: HallTicketCard,
  HallTicketTemplate2: HallTicketCard2,
  HallTicketTemplate3: HallTicketCard3,
};

const preview = prefix ? `${prefix}01A01` : "HTC1A01"; // Example
const Interpreview = prefix ? `${prefix}MPC11A01` : "HTCMPC11A01"; // Example
  const handleHallTicketPrefixSubmit = async () => {
    if (!prefix.trim()) {
      toast.error("Please enter prefix", { autoClose: 2000 });
      return;
    }

    sethallticketprefixLoading(true);
    try {
      const query = new URLSearchParams({ prefix }).toString();
      const res = await fetch(
        `${baseUrl}/api/principal/setHallTicketPrefix/${pId}?${query}`,
        { method: "PATCH" }
      );

      if (!res.ok) {
        const msg = await res.text();
        throw new Error(msg || `Status ${res.status}`);
      }

      const msg =
        (await res.text()) || "Hall-Ticket Numbers Generated  Successfully!";
      toast.success(msg, { autoClose: 1000 });
      //  handleClose();
    } catch (err) {
      console.error(err);
      toast.error(err.message || "Update failed", { autoClose: 2000 });
    } finally {
      sethallticketprefixLoading(false);
    }
  };
/* ---------- POST: GENERATE hall-ticket numbers ---------- */
const generateHallTickets = async () => {
  setGenerating(true);
  try {
    const url =
      board === "INTERMEDIATE"
        ? `${baseUrl}/api/examCell/generateIntermediateHallTickets/${oId}/${pId}?examType=${Examtype}`
        : `${baseUrl}/api/examCell/setAllStudentsHallTicketsBasedOnExam/${oId}/${pId}?examType=${Examtype}`;

    const res = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ action: "generateAll" }),
    });

    if (!res.ok) {
      // If response is error, it returns JSON
      const errorJson = await res.json();
      throw new Error(errorJson.message || "Generation failed");
    }
    const msg = await res.text();

    if (board === "INTERMEDIATE") {
      fetchCourseClassSectionTableData();
    } else {
      fetchClassSectionTableData();
    }

    handleClose();
    toast.success(msg || "Hall-tickets generated!", { autoClose: 1000 });
  } catch (err) {
    toast.error(err.message || "Generation failed", { autoClose: 2000 });
  } finally {
    setGenerating(false);
  }
};
/* ---------- DELETE: remove hall-ticket numbers ---------- */
  const deleteHallTickets = async () => {
    setDeleting(true);
    try {
      const res = await fetch(
        `${baseUrl}/api/examCell/deleteAllStudentsHallTicketsBasedOnExam/${oId}/${pId}?examType=${Examtype}`,
        { method: "DELETE" }
      );

      if (!res.ok) throw new Error(await res.text());

      const msg = (await res.text()) || "Hall-tickets deleted!";
 
   if(board === "INTERMEDIATE"){
      fetchCourseClassSectionTableData();
   }else{
      fetchClassSectionTableData();
   }
    handleClose();
   
      toast.success(msg, { autoClose: 1000 });
    } catch (err) {
      toast.error(err.message || "Deletion failed", { autoClose: 2000 });
    } finally {
      setDeleting(false);
    }
  };
 const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: "Hallticket",
  });
  // Reusable button style
  const buttonStyle = {
    padding: "8px 16px",
    borderRadius: "8px",
    color: "#fff",
    cursor: "pointer",
    fontWeight: "bold",
    fontSize: "14px",
    border: "none",
    transition: "all 0.4s ease",
  };
     const [companyInfo, setCompanyInfo] = useState({
        schoolName: "",
        pincode: "",
        primaryContact: "",
        secondaryContact: "",
        boardAffiliation: "",
        schoolAddress: "",
        affiliationNumber: "",
        city: "",
        state: "",
        schoolEmailId: "",
        schoolLogo: "",
        schoolStamp: "",
      });
      const [tempInfo, setTempInfo] = useState({ ...companyInfo });
      const [orgloading, setOrgLoading] = useState(true);
        const [users, setUsers] = useState([]);
        const [selectedUsers, setSelectedUsers] = useState("");
        const isPrincipal = role?.startsWith("PRINCIPAL") || false;
        const UserId = selectedUsers || userId;
          const fetchUsers = async () => {
              try {
                  const response = await fetch(`${baseUrl}/api/principal/getAllUserIdsAndNames/ADMISSION_FEE/${oId}/${pId}`);
                  if (!response.ok) {
                      throw new Error('Failed to fetch users');
                  }
                  const data = await response.json();
                  setUsers(data);
                  if (data.length > 0) {
                    setSelectedUsers(data[0].userId); // ✅ Set first record's userId as default
                }
              } catch (error) {
                  console.error('Error fetching users:', error);
              }
          };
      useEffect(() => {
        // if (isPrincipal) {
          fetchUsers();
        // }
      }, []); // ✅ Only runs on mount

// -------------------------------------------
//           For SSC functions
// -------------------------------------------

// ---- Fetch Class + Sections for SSC (School) ----
const fetchClassRegistrationData = async () => {
  try {
    const response = await fetch(
      // `${baseUrl}/api/dynamic-classReg/class-registrations/${oId}/${pId}`
      `${baseUrl}/api/dynamic-classReg/class-registrationsForHallTickets/${oId}/${pId}`
    );
    const data = await response.json();

    if (response.ok && Array.isArray(data)) {
      const classSectionMap = {};

      data.forEach((item) => {
        const className = item.classRegistration;
        const sections = item.sections.split(",").map((s) => s.trim());

        if (!classSectionMap[className]) {
          classSectionMap[className] = new Set();
        }

        sections.forEach((sec) => classSectionMap[className].add(sec));
      });

      const classes = Object.keys(classSectionMap);
      setSscClassOptions(classes);
      setSscClassSectionMap(classSectionMap);

      if (classes.length) {
        const defaultClass = classes[0];
        const sectionArray = [...classSectionMap[defaultClass]];

        setSscSelectedClass(defaultClass);
        setSscSectionOptions(sectionArray);
        setSscSelectedSection(sectionArray[0] || ""); // ✅ Select first section
      } else {
        setSscSelectedClass("");
        setSscSectionOptions([]);
        setSscSelectedSection("");
      }
    }
  } catch (error) {
    console.error("Error fetching SSC data:", error);
  }
};

// ---- Fetch Table Data for SSC ----
const fetchClassSectionTableData = async () => {
  if (!sscSelectedClass || !sscSelectedSection || !UserId) {
    setFilteredData([]);
    setOriginalData([]);
    setLoading(false);
    return;
  }
  setLoading(true);
  try {
    const response = await fetch(
      `${baseUrl}/api/admission/adm/getAllFilterWithClassesAndSectionHallTicket/${oId}/${UserId}?romanNumberClass=${sscSelectedClass}&sections=${sscSelectedSection}&examType=${Examtype}`
    );
    const data = await response.json();
    if (Array.isArray(data)) {

        // ✅ Sort by Roll No Ascending (1,2,3,4...)
      const sortedData = data.sort(
        (a, b) => Number(a.studentRollNumber) - Number(b.studentRollNumber)
      );


      setOriginalData(sortedData);
      setFilteredData(sortedData);
      // setUniqueCourseType([...new Set(data.map(item => item.course))]);
     
    } else {
      setOriginalData([]);
      setFilteredData([]);
    }
  } catch (error) {
    console.error("Error fetching SSC table data:", error);
  } finally {
    setLoading(false);
  }
};

// -------------------------------------------
//           For Intermediate functions
// -------------------------------------------

// ---- Fetch Courses for INTERMEDIATE ----
const fetchCourseData = async () => {
  if(!interSelectedClass) return;
  try {
    const response = await fetch(`${baseUrl}/api/dynamic-classReg/getAllcoursesAccordingClasses/${pId}?romanNumberClass=${interSelectedClass}`);
    const data = await response.json();
    if (response.ok && Array.isArray(data)) {
      setCourseOptions(data);
      if (!selectedCourseType) {
        setSelectedCourseType(data[0] || "");
      }
    } else {
      setCourseOptions([]);
    }
  } catch (error) {
    console.error("Error fetching course data:", error);
    setCourseOptions([]);
  }
};

// ---- Fetch Sections for INTERMEDIATE ----
const fetchSectionsData = async () => {
  if (!interSelectedClass || !selectedCourseType) {
    setInterSectionOptions([]);
    return;
  }
  try {
    const response = await fetch(
      `${baseUrl}/api/dynamic-classReg/getAllClass-registrations/${interSelectedClass}/${selectedCourseType}/${pId}`
    );
    const data = await response.json();
    if (response.ok && Array.isArray(data) && data.length > 0) {
      const sectionsString = data[0].sections;  // because your data is like [{ sections: "Section-A,Section-B" }]
      const sections = sectionsString.split(",").map(section => section.trim());
     
      setInterSectionOptions(sections);

      if (sections.length > 0) {
        setInterSelectedSection(sections[0]);
      } else {
        setInterSelectedSection("");
      }
    } else {
      setInterSectionOptions([]);
      setInterSelectedSection("");
    }
  } catch (error) {
    console.error("Error fetching INTERMEDIATE data:", error);
  }
};
// ---- Fetch Table Data for INTERMEDIATE ----
const fetchCourseClassSectionTableData = async () => {
  if (!selectedCourseType || !interSelectedClass || !interSelectedSection || !UserId) {
    setFilteredData([]);
    setOriginalData([]);
    setLoading(false);
    return;
  }
  setLoading(true);
  try {
    const response = await fetch(
      `${baseUrl}/api/admission/adm/getAllFilterWithClassesAndSectionHallTicket/${oId}/${UserId}?course=${selectedCourseType}&romanNumberClass=${interSelectedClass}&sections=${interSelectedSection}&examType=${Examtype}`
    );
    const data = await response.json();
    if (Array.isArray(data)) {
      setOriginalData(data);
      setFilteredData(data);
      setCourse(data.course);
      // setUniqueCourseType([...new Set(data.map(item => item.course))]);
     
    } else {
      setOriginalData([]);
      setFilteredData([]);
    }
  } catch (error) {
    console.error("Error fetching INTERMEDIATE table data:", error);
  } finally {
    setLoading(false);
  }
};

useEffect(() => {
  const loadClassData = async () => {
    if (board === "INTERMEDIATE") {
      await fetchSectionsData();
    } else if (board === "SSC") {
      await fetchClassRegistrationData();
    }
  };
  loadClassData();
}, [board,interSelectedClass, selectedCourseType, oId]);  // Removed selectedClass dependency here
// Fetch course options if board is INTERMEDIATE
useEffect(() => {
  if (board === "INTERMEDIATE") {
    fetchCourseData();
  }
}, [interSelectedClass,board, oId]);

// Fetch Table Data whenever filters change
useEffect(() => {
  if (board === "SSC") {
    if (!sscSelectedClass || !sscSelectedSection) {
      setOriginalData([])
      setFilteredData([]);
      setLoading(false); // ✅ stop loading even if API not called
      return;
    }
    fetchClassSectionTableData(); // Modify inside function to use sscSelectedClass and sscSelectedSection
  } else if (board === "INTERMEDIATE") {
    if (!interSelectedClass || !interSelectedSection || !selectedCourseType) {
      setOriginalData([])
      setFilteredData([]);
     
      setLoading(false); // ✅ same here
      return;
    }
    fetchCourseClassSectionTableData(); // Modify inside function to use interSelectedClass and interSelectedSection
  }
}, [UserId,board, sscSelectedClass, sscSelectedSection, interSelectedClass, interSelectedSection, selectedCourseType]);

  useEffect(() => {
    if (searchQuery.trim() === "") {
      setFilteredData(originalData);
    } else {
      setFilteredData(
        originalData.filter((student) => {
          const fullName = `${student.surName || ""} ${
            student.firstName || ""
          } ${student.lastName || ""}`.toLowerCase();
          return (
            student.customAdmissionNumber.toString().includes(searchQuery) ||
            fullName.includes(searchQuery.toLowerCase())
          );
        })
      );
    }
  }, [searchQuery, originalData]);
  //organization details api
        useEffect(() => {
          const fetchCompanyInfo = async () => {
            try {
              const response = await fetch(`${baseUrl}/api/v1/organisation/${oId}`);
              if (!response.ok) {
                throw new Error("Network response was not ok");
              }
             
     
              const data = await response.json();
              setCompanyInfo({
                schoolLogo: data.schoolLogo,
                schoolStamp:data.schoolStamp,
                schoolName: data.schoolName,
                city: data.city,
                state: data.state,
                affiliationNumber: data.affiliationNumber,
                schoolAddress: data.schoolAddress,
                primaryContact: data.primaryContact,
                boardAffiliation: data.boardAffiliation,
                secondaryContact: data.secondaryContact,
                pincode: data.pincode,
                schoolEmailId: data.schoolEmailId,
              });
              setTempInfo(data);
     
              setOrgLoading(false); // Data fetched, stop loading
     
            } catch (error) {
              console.error("Error fetching company info:", error);
              setOrgLoading(false); // Stop loading even if there's an error
            }
          };
     
          fetchCompanyInfo();
        }, []);

  const [examUsers, setExamUsers] = useState([]);
  const [selectedExamUsers, setSelectedxamUsers] = useState("");
  // const isPrincipal = role?.startsWith("PRINCIPAL") || false;
  const ExamUserId = userId || selectedExamUsers;
  const [filteredExamData, setFilteredExamData] = useState([]);
const [examloading, setExamLoading] = useState(true);
    const fetchExaminationUsers = async () => {
        try {
            const response = await fetch(`${baseUrl}/api/principal/getAllUserIdsAndNames/EXAMINATION_CELL/${oId}/${pId}`);
            if (!response.ok) {
                throw new Error('Failed to fetch users');
            }
            const data = await response.json();
            setExamUsers(data);
            if (data.length > 0) {
              setSelectedxamUsers(data[0].userId); // ✅ Set first record's userId as default
          }
        } catch (error) {
            console.error('Error fetching users:', error);
        }
    };
useEffect(() => {
  if (isPrincipal) {
    fetchExaminationUsers();
  }
}, []); // ✅ Only runs on mount

  // ---- Fetch Table Data for SSC ----
const fetchSscHallticketTableData = async (sscSelectedClass, Examtype) => {
  if (!ExamUserId || !sscSelectedClass ||!sscSelectedSection || !Examtype) {
    setFilteredExamData([]);
    setExamLoading(false);
    return;
  }

  setExamLoading(true);
  try {
    const response = await fetch(
     
      `${baseUrl}/api/examCell/getWithRomanNumberClassWithExamType/${oId}/${pId}/${ExamUserId}?romanNumberClass=${sscSelectedClass}&sections=${sscSelectedSection}&examType=${Examtype}`
    );
    const data = await response.json();

    if (Array.isArray(data) && data.length > 0) {
      setFilteredExamData(data);
    } else {
      setFilteredExamData([]);
    }
  } catch (error) {
    console.error("Error fetching exam timetable:", error);
  } finally {
    setExamLoading(false);
  }
};
useEffect(() => {
  if (board === "SSC" && sscSelectedClass && Examtype && oId) {
    fetchSscHallticketTableData(sscSelectedClass, Examtype);
  }
 
}, [ExamUserId,sscSelectedClass,sscSelectedSection, Examtype, board, oId]);
  // ---- Fetch Table Data for INTERMEDIATE ----
const fetchInterHallticketTableData = async (romanNumberClass, Examtype,course) => {
  if (!ExamUserId || !romanNumberClass ||!interSelectedSection || !Examtype ||!course) {
    setFilteredExamData([]);
    setExamLoading(false);
    return;
  }

  setExamLoading(true);
  try {
    const response = await fetch(
     
      `${baseUrl}/api/examCell/getWithRomanNumberClassWithExamType/${oId}/${pId}/${ExamUserId}?romanNumberClass=${romanNumberClass}&sections=${interSelectedSection}&examType=${Examtype}&course=${course}`
    );
    const data = await response.json();

    if (Array.isArray(data) && data.length > 0) {
      setFilteredExamData(data);
    } else {
      setFilteredExamData([]);
    }
  } catch (error) {
    console.error("Error fetching exam timetable:", error);
  } finally {
    setExamLoading(false);
  }
};
useEffect(() => {
  if (board === "INTERMEDIATE" && interSelectedClass && Examtype && oId && course) {
    fetchInterHallticketTableData(interSelectedClass, Examtype,course);
  }
 
}, [ExamUserId,interSelectedClass,interSelectedSection, course,Examtype, board, oId]);

  return (
    <Box sx={{ mt: "5%", mr: "1%", ml: "1%" }}>
      <Card
        sx={{
          marginTop: "60px",
          width: "100%",
          borderRadius: 3,
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
        }}
      >
        <CardContent>
         <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ marginBottom: 2 }}>
  {/* Left side: Back button + Heading */}
  <Box display="flex" alignItems="center">
    <IconButton onClick={() => navigate(-1)} sx={{ color: '#2e2a54' }}>
      <KeyboardBackspaceIcon fontSize="medium" />
    </IconButton>
    <Typography variant="h5" component="h3" sx={{ fontWeight: 'bold', ml: 1 }}>
      {`${Examtype}-Students HallTickets List`}
    </Typography>
  </Box>

  <Box display="flex" alignItems="center" gap={2}>
  <Button
    variant="contained"
    sx={{
      backgroundColor: "#3C3972",
      fontWeight: "bold",
      "&:hover": { backgroundColor: "#3C3972" },
      marginRight:'5px'
    }}
    onClick={handleOpen}
  >
    Generate Hallticket No
  </Button>
            <button
          onClick={handlePrint}
          style={{
            ...buttonStyle,
            background: "linear-gradient(90deg, #3C3972, #3C3972)",
            boxShadow: "0 5px 10px rgba(30, 144, 255, 0.3)",
          }}
        >
          Print HallTickets
        </button>
         </Box>
</Box>
          <Box display="flex" mb={3} flexWrap="wrap">
            <TextField
              label="Search by Admission Number"
              variant="outlined"
              size="small"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              sx={{ marginRight: 2 }}
            />
       {board === "SSC" && (
                                       <>
                                         <FormControl size="small" sx={{ minWidth: 120, marginRight: 2 }}>
                                           <InputLabel id="class-select-label">Select Class</InputLabel>
                                           <Select
                                             labelId="class-select-label"
                                             value={sscSelectedClass}
                                             onChange={(e) => {
                                              const selected = e.target.value;
                                              setSscSelectedClass(selected);
                                         
                                         
                                              const sections = sscClassSectionMap[selected] ? Array.from(sscClassSectionMap[selected]) : [];
                                              setSscSectionOptions(sections);
                                              setSscSelectedSection(sections.includes("Section-A") ? "Section-A" : sections[0] || "");
                                            }}
                                           
                                             label="Select Class"
                                             sx={{ height: 35 }}
                                           >
                                             {sscClassOptions.map((cls) => (
                                               <MenuItem key={cls} value={cls}>{cls}</MenuItem>
                                             ))}
                                           </Select>
                                         </FormControl>
                                     
                                         <FormControl size="small" sx={{ minWidth: 120, marginRight: 2 }}>
                                           <InputLabel id="section-select-label">Select Section</InputLabel>
                                           <Select
                                             labelId="section-select-label"
                                             value={sscSelectedSection}
                                             onChange={(e) => setSscSelectedSection(e.target.value)}
                                             label="Select Section"
                                             sx={{ height: 35 }}
                                             disabled={sscSectionOptions.length === 0}
                                           >
                                             {sscSectionOptions.map((section) => (
                                               <MenuItem key={section} value={section}>{section}</MenuItem>
                                             ))}
                                           </Select>
                                         </FormControl>
                                       </>
                                     )}
                                     
                                     
                                     {board === "INTERMEDIATE" && (
                                       <>
                                         <FormControl size="small" sx={{ minWidth: 120, marginRight: 2 }}>
                                           <InputLabel id="intermediate-class-select-label">Select Year</InputLabel>
                                           <Select
                                             labelId="intermediate-class-select-label"
                                             value={interSelectedClass}
                                             onChange={(e) => setInterSelectedClass(e.target.value)}
                                             label="Select Year"
                                             sx={{ height: 35 }}
                                           >
                                             <MenuItem value="Inter-1st-Year">Inter-1st-Year</MenuItem>
                                             <MenuItem value="Inter-2nd-Year">Inter-2nd-Year</MenuItem>
                                           </Select>
                                         </FormControl>
                                     
                                         <FormControl size="small" sx={{ minWidth: 120, marginRight: 2 }}>
                                           <InputLabel id="course-type-label">Select Course</InputLabel>
                                           <Select
                                             labelId="course-type-label"
                                             value={selectedCourseType}
                                             onChange={(e) => setSelectedCourseType(e.target.value)}
                                             label="Select Course"
                                             sx={{ height: 35 }}
                                           >
                                             {courseOptions.map((course, index) => (
                                               <MenuItem key={index} value={course}>{course}</MenuItem>
                                             ))}
                                           </Select>
                                         </FormControl>
                                     
                                         <FormControl size="small" sx={{ minWidth: 120, marginRight: 2 }}>
                                           <InputLabel id="intermediate-section-select-label">Select Section</InputLabel>
                                           <Select
                                             labelId="intermediate-section-select-label"
                                             value={interSelectedSection}
                                             onChange={(e) => setInterSelectedSection(e.target.value)}
                                             label="Select Section"
                                             sx={{ height: 35 }}
                                           >
                                             {interSectionOptions.map((section, index) => (
                                               <MenuItem key={index} value={section}>{section}</MenuItem>
                                             ))}
                                           </Select>
                                         </FormControl>
                                       </>
                                     )}
          </Box>
<div ref={componentRef} className="print-wrapper">
  {filteredData.map((student, i) => {
    const SelectedComponent = themeComponents[selectedHallTheme] || HallTicketCard;
    return (
      <div key={i} className="print-card">
        <SelectedComponent
          student={student}
          organizationDetails={companyInfo}
          board={board}
          filteredExamData={filteredExamData}
          Examtype={Examtype}
        />
      </div>
    );
  })}
</div>



        <GlobalStyles
          styles={{
            "@media print": {
              "@page": {
                size: "A4",
                margin: 6, // Remove browser default page margins
              },
              body: {
                margin: 0,
                padding: 0,
              },
              ".print-wrapper": {
                display: "flex",  
                flexDirection: "column",
                margin: 0,
                padding: 0,
              },
              // ".print-card": {
              //   width: "100%",
              //    height: "82mm",        
              //     maxHeight: "82mm",
              //     overflow: "hidden",
              //     // marginBottom: "6mm",
              //   // margin: "30px 0 0 0",
              //   margin: "4mm 0",

              //   // padding: 0,
              //   pageBreakInside: "avoid",
              // },

              ".print-card": {
                height: "88mm",
                maxHeight: "88mm",
                margin: "7mm 0",
                pageBreakInside: "avoid",
                breakInside: "avoid",
              },

                ".print-inner": {
                height: "100%",
                width: "100%",
                border: "2px solid black",
                boxSizing: "border-box",
                padding: "4px",        
                display: "inline-block",
              },
              
              /* AFTER EVERY 3 HALL TICKETS → NEW PAGE */
              ".print-wrapper > .print-card:nth-child(3n)": {
                marginBottom: "0",  
                pageBreakAfter: "always", // Keep 2 cards per page
              },
            },
          }}
        />

          <TableContainer
            component={Paper}
            sx={{
              borderRadius: 2,
              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
              maxHeight: "800px",
              overflow: "auto",
            }}
            className="custom-sidebar-scrollbar"
          >
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell
                    sx={{
                      borderRight: "1px solid #ddd",
                      padding: "4px",
                      textAlign: "center",
                      backgroundColor: "#fff9c4",
                      fontWeight:'bold',
                      fontSize:'14px'
                    }}
                  >
                    S.No
                  </TableCell>
                  <TableCell
                    sx={{
                      borderRight: "2px solid #ddd",
                      padding: "4px",
                      textAlign: "center",
                      backgroundColor: "#fff9c4",
                      fontWeight:'bold',
                      fontSize:'14px'
                    }}
                  >
                    Admission No
                  </TableCell>
                  {(board === "INTERMEDIATE" ) && (
                  <TableCell
                    sx={{
                      borderRight: "1px solid #ddd",
                      padding: "4px",
                      backgroundColor: "#fff9c4",
                      textAlign: "center",
                      fontWeight: "Bold",
                    }}
                  >
                    Course
                  </TableCell>
                  )}

                  <TableCell
                    sx={{
                      borderRight: "2px solid #ddd",
                      padding: "4px",
                      backgroundColor: "#fff9c4",
                      textAlign: "center",
                      fontWeight:'bold',
                      fontSize:'14px'
                    }}
                  >
                    {board === "INTERMEDIATE" ? "Year" : "Class"}
                  </TableCell>
                  <TableCell
                    sx={{
                      borderRight: "1px solid #ddd",
                      padding: "4px",
                      backgroundColor: "#fff9c4",
                      textAlign: "center",
                      fontWeight:'bold',
                      fontSize:'14px'
                    }}
                  >
                    Section
                  </TableCell>

                  <TableCell
                    sx={{
                      borderRight: "2px solid #ddd",
                      padding: "4px",
                      textAlign: "center",
                      whiteSpace: "nowrap",
                      backgroundColor: "#fff9c4",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      fontWeight:'bold',
                      fontSize:'14px'
                    }}
                  >
                    Name
                  </TableCell>

                  <TableCell
                    sx={{
                      borderRight: "1px solid #ddd",
                      padding: "4px",
                      textAlign: "center",
                      whiteSpace: "nowrap",
                      backgroundColor: "#fff9c4",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      fontWeight:'bold',
                      fontSize:'14px'
                    }}
                  >
                    Father Name
                  </TableCell>
                  <TableCell
                    sx={{
                      borderRight: "1px solid #ddd",
                      padding: "4px",
                      textAlign: "center",
                      backgroundColor: "#fff9c4",
                      fontWeight:'bold',
                      fontSize:'14px'
                    }}
                  >
                    Roll No
                  </TableCell>
                 
                                    <TableCell
                    sx={{
                      borderRight: "1px solid #ddd",
                      padding: "4px",
                      backgroundColor: "#fff9c4",
                      textAlign: "center",
                      fontWeight:'bold',
                      fontSize:'14px'
                    }}
                  >
                    HallTicket No
                  </TableCell>

                  <TableCell
                    sx={{
                      padding: "4px",
                      backgroundColor: "#fff9c4",
                      textAlign: "center",
                      fontWeight:'bold',
                      fontSize:'14px'
                    }}
                  >
                    Document
                  </TableCell>
                </TableRow>
              </TableHead>
              {loading ? (
                <TableBody>
                  <TableRow>
                    <TableCell
                      colSpan={13}
                      style={{ textAlign: "center", padding: "20px" }}
                    >
                      <Box
                        display="flex"
                        flexDirection="column"
                        alignItems="center"
                      >
                        <CircularProgress />
                        <Typography variant="body2" sx={{ mt: 1 }}>
                          Loading Data...
                        </Typography>
                      </Box>
                    </TableCell>
                  </TableRow>
                </TableBody>
              ) : filteredData.length === 0 ? (
                <TableBody>
                  <TableRow>
                    <TableCell colSpan={13} sx={{ textAlign: "center" }}>
                      No data found
                    </TableCell>
                  </TableRow>
                </TableBody>
              ) : (
                <TableBody>
                  {filteredData.map((row, index) => (
                    <TableRow
                      key={row.admissionNumber}
                      style={{
                        backgroundColor: "white",
                        transition: "background-color 0.3s",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = "#f5f5f5"; // Hover color
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = "white"; // Default color
                      }}
                    >
                      <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "4px",
                          textAlign: "center",
                        }}
                      >
                        {index + 1}
                      </TableCell>

                      <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "4px",
                          textAlign: "center",
                        }}
                      >
                        {row.customAdmissionNumber}
                      </TableCell>

                      {board === "INTERMEDIATE" && (
                      <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "4px",
                          textAlign: "center",
                        }}
                      >
                        {row.course}
                      </TableCell>
                      )}

                      <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "3px",
                          textAlign: "center",
                        }}
                      >
                        {["NURSERY", "LKG", "UKG"].includes(
                          row.romanNumberClass?.toString().trim()
                        )
                          ? row.romanNumberClass
                          : `${row.romanNumberClass}`}
                      </TableCell>

                      <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "4px",
                          textAlign: "center",
                        }}
                      >
                        {row.sections}
                      </TableCell>

                      <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "4px",
                          textAlign: "center",
                        }}
                      >{`${row.firstName} ${row.lastName}`}</TableCell>
                     <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "4px",
                          textAlign: "center",
                        }}
                      >
                        {row.fathersFirstName || row.fathersLastName
                          ? `${row.fathersFirstName || ""} ${row.fathersLastName || ""}`.trim()
                          : "NA"}
                      </TableCell>

                      <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "4px",
                          textAlign: "center",
                        }}
                      >
                        {row.studentRollNumber || "N/A"}
                      </TableCell>
                     
                                            <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "4px",
                          textAlign: "center",
                        }}
                      >
                        {row.studentHallTicket || "N/A"}
                      </TableCell>

                      <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "4px",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          textAlign: "center",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "center",
                            gap: "4px",
                          }}
                        >
                          <Button
                            type="button"
                            onClick={() =>
                              navigate(`/${selectedHallTheme}/${row.admissionNumber}/${Examtype}`)
                            }
                            sx={{
                              backgroundColor: "#1976d2",
                              color: "white",
                              fontSize: "0.6rem", // Reduces the font size
                              // padding: "5px 10px",  // Reduces the padding
                              height: "25px", // Reduces the height
                              "&:hover": {
                                backgroundColor: "#1565c0",
                              },
                            }}
                          >
                            HallTicket
                          </Button>
                        </div>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              )}
            </Table>
          </TableContainer>
{/* //Dialog Code */}
<Dialog open={open} onClose={handleClose} maxWidth="sm" >
  <DialogTitle
    sx={{
      fontWeight: 'bold',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      pr: 2,
    }}
  >
    {`Generate ${Examtype} Hallticket Numbers`}
    <IconButton onClick={handleClose} size="small">
      <CloseIcon />
    </IconButton>
  </DialogTitle>

  <DialogContent>
    <CardContent>
      <Typography variant="h5" fontWeight="bold" gutterBottom>
        Configure Hall-Ticket Prefix
      </Typography>

      {/* Explanation Section (smaller) */}
      {board === "SSC" &&(
      <Paper
        elevation={2}
        sx={{
          p: 1.5,
          backgroundColor: "#fff8e1",
          border: "1px solid #ffc107",
          borderRadius: 2,
          mb: 2,
          mt: 1,
          width: "100%",
          mx: "auto",
          fontSize: "0.85rem",
          lineHeight: 1.5,
        }}
      >
        <Typography variant="subtitle2" fontWeight="bold" color="#ff9800" gutterBottom>
          Hall Ticket Number Format Explanation:
        </Typography>
        <ul style={{ paddingLeft: "18px", margin: 0 }}>
          <li><b>Prefix (3 chars max)</b>: Letters/numbers like <code>HTC,658</code></li>
          <li><b>Class (1 digits)</b>: e.g., <code>1</code> for Class-I</li>
          <li><b>Section (1 letter)</b>: e.g., <code>A </code> for Section-A</li>
          <li><b>Roll Number (2 digits)</b>: Unique student number in that class-section (e.g., <code>01</code>)</li>
        </ul>
        <Typography sx={{ mt: 1 }}>
          <b>Example:</b> <code>HTC1A01</code> → <b>Prefix:</b> HTC, <b>Class:</b> 1, <b>Section:</b> A, <b>Roll No:</b> 01
        </Typography>
       <Typography sx={{ mt: 1, fontSize: "0.65rem" }}>
          <b>Important:</b> <code>After submitting, Below click on the "Generate Hall Ticket Numbers for All Students" button.</code>
        </Typography>

        <Typography sx={{ mt: 1, fontSize: "0.65rem" }}>
          <b>Note:</b> <code>If the hall ticket numbers are not in the correct format, click on the "Delete Hall Ticket Numbers" button. This will remove all generated hall ticket numbers for all classes.</code>
        </Typography>

      </Paper>
)}
  {board === "INTERMEDIATE" &&(
      <Paper
        elevation={2}
        sx={{
          p: 1.5,
          backgroundColor: "#fff8e1",
          border: "1px solid #ffc107",
          borderRadius: 2,
          mb: 2,
          mt: 1,
          width: "90%",
          mx: "auto",
          fontSize: "0.85rem",
          lineHeight: 1.5,
        }}
      >
        <Typography variant="subtitle2" fontWeight="bold" color="#ff9800" gutterBottom>
          Hall Ticket Number Format Explanation:
        </Typography>
        <ul style={{ paddingLeft: "18px", margin: 0 }}>
          <li><b>Prefix (3 chars max)</b>: Letters/numbers like <code>HTC,658</code></li>
          <li><b>Course (3 Letters)</b>: e.g., <code>MPC</code> for MPC</li>
          <li><b>Class (2 digits)</b>: e.g., <code>11</code> for Inter-1st-Year</li>
          <li><b>Section (1 letter)</b>: e.g., <code>A </code> for Section-A</li>
          <li><b>Roll Number (2 digits)</b>: Unique student number in that class-section (e.g., <code>01</code>)</li>
        </ul>
        <Typography sx={{ mt: 1 }}>
          <b>Example:</b> <code>HTCMPC11A01</code> → <b>Prefix:</b> HTC,<b>Course:</b> MPC, <b>Inter-1st-Year:</b> 11, <b>Section:</b> A, <b>Roll No:</b> 01
        </Typography>
      </Paper>
)}
      {/* Preview */}
       {board === "SSC" &&(
      <Paper
        elevation={3}
        sx={{
          my: 2,
          p: 1.5,
          backgroundColor: "#e0f7fa",
          textAlign: "center",
          fontSize: "1.1rem",
          fontWeight: 600,
          color: "#00796b",
          width: "75%",
          mx: "auto",
        }}
      >
        Preview: {preview}
      </Paper>
)}

       {board === "INTERMEDIATE" &&(
      <Paper
        elevation={3}
        sx={{
          my: 2,
          p: 1.5,
          backgroundColor: "#e0f7fa",
          textAlign: "center",
          fontSize: "1.1rem",
          fontWeight: 600,
          color: "#00796b",
          width: "75%",
          mx: "auto",
        }}
      >
        Preview: {Interpreview}
      </Paper>
)}
      {/* Form Input */}
      <Stack spacing={2} alignItems="center">
        <TextField
          label="Prefix"
          value={prefix}
          onChange={(e) => {
            const input = e.target.value.toUpperCase();
            if (/^[A-Z0-9]*$/.test(input) && input.length <= 4) {
              setHallTicketPrefix(input);
            }
          }}
          sx={{ width: "440px" }}
          required
          size="medium"
        />

        <Button
          variant="contained"
          onClick={handleHallTicketPrefixSubmit}
          disabled={hallticketprefixloading}
          sx={{
            minWidth: 120,
            minHeight: 45,
            backgroundColor: "#3C3972",
            fontWeight: "bold",
            "&:hover": { backgroundColor: "#3C3972" },
          }}
        >
          {hallticketprefixloading ? (
            <CircularProgress size={24} sx={{ color: "#fff" }} />
          ) : (
            "Submit"
          )}
        </Button>
      </Stack>

{/* //BUTTON GENERATION */}
<Box
  sx={{
    display: "flex",
    justifyContent: "center",
    mt: 4, // Add top margin for spacing
  }}
>
  <Stack direction="row" spacing={2} alignItems="center">
    {/* Generate button */}
    <Button
      variant="contained"
      color="primary"
      onClick={generateHallTickets}
      disabled={generating}
      sx={{
        minWidth: 240,
        backgroundColor: "#3C3972",
        "&:hover": { backgroundColor: "#3C3972" },
      }}
    >
      {generating ? (
        <CircularProgress size={24} sx={{ color: "#fff" }} />
      ) : (
        "Generate Hall-ticket Number for All Students"
      )}
    </Button>

    {/* Delete button */}
    <Button
      variant="contained"
      color="error"
      onClick={deleteHallTickets}
      disabled={deleting}
      sx={{ minWidth: 240 }}
    >
      {deleting ? (
        <CircularProgress size={24} sx={{ color: "#fff" }} />
      ) : (
        "Delete Hall-ticket Number for All Students"
      )}
    </Button>
  </Stack>
</Box>
    </CardContent>
  </DialogContent>
</Dialog>
      <ToastContainer  position="top-right"  autoClose={2000} />
        </CardContent>
      </Card>
    </Box>
  );
};

export default Hallticketslist;